import ChatNavigationSettings from './Settings';

export default ChatNavigationSettings;
